export enum SessionStorageKeys {
  contactUsAccordionSegmentTitle = "contactUsAccordionSegmentTitle",
  contactUsAccordionSectionTitle = "contactUsAccordionSectionTitle",
  contactFormSlug = "contactFormSlug",
  chatBotInUse = "chatBotInUse"
}
